import { Injectable } from '@angular/core';

import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { formconfig } from '../../configuration/formconfig/formconfig';
import { environment } from '../../../environments/environment';
import { FormDashboard } from './formdashboard';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class FormdashboardService {

  constructor(private httpClient: HttpClient) { }
  baseUrl: string = environment.serviceUrl;

  getFormConfig(): Observable<formconfig[]> {
    return this.httpClient.get<formconfig[]>(this.baseUrl + 'api/FormConfigApi/');
  };

  getFormDetails(form: formconfig): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/GetFormdetails/' + form.formconfigname.toLocaleLowerCase());
  };

  getAllMasterDetails(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/GetAllMasterDetails/');
  };

  insertDocumentStatus(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/AddDocument', data, { headers: header, observe: 'response' });
  }
  getDocumentStatus(formdata: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getDocumentStatus/' + formdata);
  };
  GetUnreadFormCount(userid: number, tablename: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/UnreadFormCount/' + userid + '?tablename=' + tablename);
  }
  RemoveFormDocument(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormRenderApi/activeordeactive', data, { headers: header, observe: 'response' });
  }
  getformsearchdetails(userid: number): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/formsearchdetails/' + userid, { headers: header, observe: 'response' });
  }
  insertAdvancedSearch(model: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/Addadvancedsearch', model, { headers: header, observe: 'response' });
  }

  removeAdvancedSearch(formAdvancedSearch: FormDashboard): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/Deleteadvancedsearch', formAdvancedSearch, { headers: header, observe: 'response' });
  }
  getAllAdvancedSearch(): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getAllAdvancedSearch');
  }

  getformadvancedsearchdetails(formdata: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/formadvancedsearchdetails', formdata, { headers: header, observe: 'response' });
  };
  getformadvancedsearchdetailscount(formdata: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getformadvancedsearchdetailscount', formdata, { headers: header, observe: 'response' });
  };

  getSelectedDocumentDetails(formconfigdetails: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getSelectedDocumentDetails/' + formconfigdetails);
  };
  getAllFormDocumentDetails(obj: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetails', obj, { headers: header, observe: 'response' });
  }

  getAllFormDocumentDetailscount(obj: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetailscount', obj, { headers: header, observe: 'response' });
  }


  getformadvancedsearchpreviewdetails(obj: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getformadvancedsearchpreviewdetails', obj, { headers: header, observe: 'response' });
  }
  getExportToExcel(formconfigid: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getExportToExcel/' + formconfigid);
  };

  getformsearchdetailsfieldnametreeview(userid: number,archiveformconfigid:number,achieveyar:number): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getformsearchdetailsfieldnametreeview/' + userid + '/' + archiveformconfigid + '/' + achieveyar);
  }

  getformadvancedsearchdetailsExportToExcel(formdata: string): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getformadvancedsearchdetailsExportToExcel/' + formdata);
  };
  getformsearchdetailsfieldname(formconfid: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/getformsearchdetailsfieldname/' + formconfid, { headers: header, observe: 'response' });
  }
  //getAllFormDocumentDetailsSorting(obj: any): Observable<any> {
  //  return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetailsSorting', obj, { headers: header, observe: 'response' });
  //}

    getAllFormDocumentDetailsSorting(obj: any): Observable<any> {
      return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getAllFormDocumentDetails', obj, { headers: header, observe: 'response' });
  }
  

  getformadvancedsearchdetailsSorting(formdata: string, pageno: number, itemsperpage: number, sorting: string): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/getformadvancedsearchdetailsSorting/' + formdata + '/' + pageno + '/' + itemsperpage + '/' + sorting, { headers: header, observe: 'response' });
  };

  getadvancedsearchById(advancedsearchid: number): Observable<any> {
    return this.httpClient.get<any>(this.baseUrl + 'api/FormDashboardApi/GetadvancedsearchById/' + advancedsearchid);
  }
  getpagepreferencedetails(model): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/GetPagePreferenceDetails', model);
  }

  addpagepreferencedetails(model): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/AddPagePreferenceDetails', model);
  }
  insertDocumentReadStatus(data: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/FormDashboardApi/AddDocumentReadStatus', data, { headers: header, observe: 'response' });
  }

}
